import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '../admin/AuthContext';
import Register from './Register';
import Wizard from './Wizard';

function RegisterGate() {
  const { user, tenant, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center bg-paelbi-bg text-paelbi-ink/50">Caricamento...</div>;
  if (user) {
    if (user.role === 'super_admin') return <Navigate to="/admin" replace />;
    if (tenant && (tenant.published || tenant.settings?.onboarding?.completed)) return <Navigate to="/admin" replace />;
    return <Navigate to="/onboarding/wizard" replace />;
  }
  return <Register />;
}

export function OnboardingApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="" element={<RegisterGate />} />
        <Route path="wizard" element={<Wizard />} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default OnboardingApp;
